import React from 'react';
import PropTypes from 'prop-types';
import Responsive from 'react-responsive';
import theme from 'theme/theme';
import { useGetMyContactQuery } from 'contacts/store/contactService';
import { useAppSelector } from 'store/hooks';
import { getAccessToken } from 'auth';
import Dropdown, { DropdownContent, DropdownTrigger, DropdownLink } from '../Dropdown/index';
import Flex from '../Flex/index';
import { ChevronDownIcon } from '../Icon/index';
import ProfilePicture from '../ProfilePicture/index';

const ProfileDropdown = ({ name, handleLogout, openModal, className }) => {
  const { data: myContact } = useGetMyContactQuery();
  const token = useAppSelector(getAccessToken);
  return (
    <Flex alignItems="center" pullRight className={className}>
      <Dropdown pullRight>
        <DropdownTrigger>
          <Flex
            alignItems="center"
            style={{
              color: theme.colors.primary,
            }}
          >
            <Responsive minWidth={theme.breakpoints.desktop}>
              <ProfilePicture
                contactId={myContact && myContact.id}
                mediaId={myContact?.image?.id}
                size="small"
                style={{ marginRight: '10px' }}
                token={token}
              />
            </Responsive>
            <Responsive maxWidth={theme.breakpoints.desktop}>
              <ProfilePicture
                contactId={myContact && myContact.id}
                mediaId={myContact?.image?.id}
                size="small"
                style={{ marginRight: '3px' }}
                token={token}
              />
            </Responsive>
            <Responsive minWidth={theme.breakpoints.desktop}>{name}</Responsive>
            <ChevronDownIcon
              size="1.3em"
              style={{
                transform: 'rotate(-90deg)',
                marginTop: '-3px',
              }}
            />
          </Flex>
        </DropdownTrigger>
        <DropdownContent>
          {myContact && <DropdownLink onClick={() => openModal('MY_CONTACT_EDIT')}>Edit my contact info</DropdownLink>}
          <DropdownLink onClick={() => openModal('CHANGE_PASSWORD')}>Change password</DropdownLink>
          <DropdownLink onClick={handleLogout}>Logout</DropdownLink>
        </DropdownContent>
      </Dropdown>
    </Flex>
  );
};
ProfileDropdown.propTypes = {
  name: PropTypes.string.isRequired,
  handleLogout: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  className: PropTypes.string,
};
ProfileDropdown.defaultProps = {
  className: '',
};

export default ProfileDropdown;
